import { SectionAccordionItem } from './SectionAccordionItem';
import type { SectionExecution } from '../../services/procedure-execution.service';

interface Props {
  inspectionId: string;
  sections: SectionExecution[];
  canExecute: boolean;
}

export function SectionAccordionList({ inspectionId, sections, canExecute }: Props) {
  let stepOffset = 0;

  return (
    <div className="space-y-2">
      {sections.map((section, idx) => {
        const offset = stepOffset;
        stepOffset += section.steps.length;
        return (
          <SectionAccordionItem
            key={section.sectionSnapshotId}
            inspectionId={inspectionId}
            section={section}
            sectionIndex={idx}
            globalStepOffset={offset}
            canExecute={canExecute}
          />
        );
      })}
    </div>
  );
}
